import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import Contact from "../pages/contact/page";
import Suppliers from "../pages/suppliers/page";
import Services from "../pages/services/page";
import Terms from "../pages/terms/page";
import HomeFr from "../pages/home-fr/page";
import ProductsFr from "../pages/products-fr/page";
import ContactFr from "../pages/contact-fr/page";
import SuppliersFr from "../pages/suppliers-fr/page";
import ServicesFr from "../pages/services-fr/page";
import TermsFr from "../pages/terms-fr/page";

const routes: RouteObject[] = [
  // English routes
  { path: "/", element: <Home /> },
  { path: "/products", element: <Products /> },
  { path: "/contact", element: <Contact /> },
  { path: "/suppliers", element: <Suppliers /> },
  { path: "/services", element: <Services /> },
  { path: "/terms", element: <Terms /> },
  // French routes
  { path: "/fr", element: <HomeFr /> },
  { path: "/fr/produits", element: <ProductsFr /> },
  { path: "/fr/contact", element: <ContactFr /> },
  { path: "/fr/fournisseurs", element: <SuppliersFr /> },
  { path: "/fr/services", element: <ServicesFr /> },
  { path: "/fr/conditions", element: <TermsFr /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
